module.exports = __webpack_public_path__ + "static/poligono_13_02-9f4c72a4a2ea43594621ad73bc77005f.jpg";